import { useContext, useEffect, useState } from 'react';
import { LoaderContext } from '../../../shared/context/loaderContext';
import { NotificationContext } from '../../../shared/context/notificationContext';
import { CONFIG_TABLE } from '../../../shared/const/app.config';
import { useCm360Api } from '../../../shared/const/api-backend';
import { UserDataContext } from 'shared/context/userDataContext';
import { reportError } from 'shared/services/raygunService';

const apiStrapiUrl = process.env.REACT_APP_STRAPI_API;

const useFetchQuotesData = () => {
  const { selectedBusinessUnit, selectedBrand, sessionContext } =
    useContext(UserDataContext);
  const { setLoading } = useContext(LoaderContext);
  const { showNotification } = useContext(NotificationContext);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const API = useCm360Api();

  const fetchData = async (searchTerm) => {
    setLoading(true);
    try {
      let apiUrl = `quotes?offset=0&limit=${CONFIG_TABLE.MAX_ROWS_FROM_BACKEND}`;

      if (searchTerm) {
        apiUrl += `&filter=${searchTerm}`;
      }

      const response = await API.get(apiUrl);
      setData(response.data);
    } catch (error) {
      showNotification('COMMON.error.fetchingData', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedBrand && !selectedBusinessUnit) {
      showNotification('COMMON.error.noBusinessUnitSelected', 'error');
      return;
    } else if (
      selectedBrand?.length === 0 ||
      selectedBusinessUnit?.length === 0
    ) {
      return;
    }
    fetchData();
  }, [sessionContext]);

  return { data, error, fetchData };
};

export default useFetchQuotesData;
